export interface FleetSpectralSystem {
  readonly name: string;
  readonly cluster: number;
  readonly x: number;
  readonly y: number;
  readonly kappa: number;
  readonly regime: "R1" | "R2" | "R3";
}

export interface ScatterPoint {
  readonly leftPercent: number;
  readonly topPercent: number;
}

export const FLEET_SPECTRAL_SYSTEMS: readonly FleetSpectralSystem[] = [
  { name: "auth-svc", cluster: 0, x: -1.2, y: 0.5, kappa: 4, regime: "R1" },
  { name: "data-api", cluster: 0, x: -0.8, y: 0.3, kappa: 6, regime: "R1" },
  { name: "user-mgr", cluster: 0, x: -1.0, y: 0.8, kappa: 2, regime: "R1" },
  { name: "analytics", cluster: 1, x: 1.5, y: -0.8, kappa: 24, regime: "R2" },
  { name: "ml-pipe", cluster: 1, x: 1.8, y: -0.5, kappa: 30, regime: "R3" },
];

export function scatterPoint(system: FleetSpectralSystem): ScatterPoint {
  return {
    leftPercent: 50 + system.x * 25,
    topPercent: 50 + system.y * 25,
  };
}
